import { faArrowRotateBack, faComment, faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import VoxelButton from '../../../../../components/voxel/Buttons/VoxelButton';
import VoxelTextarea from '../../../../../components/voxel/Forms/VoxelTextArea';
import VoxelText from '../../../../../components/voxel/Text/VoxelText';
import { ContentTaskGq } from '../../../../../graphql/projects/models/ContentTaskGq';
import { UpdateTaskDetailsCommand } from '../../../../../graphql/projects/mutations/contentPlan/useUpdateTaskDetailsGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';

export interface ContentTaskCommentProps {
  reload: () => Promise<unknown>;
  contentTask: ContentTaskGq;
  valueKey: keyof UpdateTaskDetailsCommand;
  newValue?: string;
  setUpdating: Dispatch<SetStateAction<boolean>>;
  updating: boolean;
}

export const ContentTaskComment: React.FC<ContentTaskCommentProps> = ({
  reload,
  contentTask,
  valueKey,
  updating,
  setUpdating,
  newValue,
}) => {
  // Form logic
  const initialValue = newValue ?? '';
  const [value, setValue] = useState<string>(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleCancel = () => setValue(newValue ?? '');

  const mutation = projectsApiService.mutations.contentPlan.useUpdateTaskDetails();
  const handleSubmit = () => {
    setUpdating(true);
    mutation({ taskId: contentTask.id, [valueKey]: value, projectId: contentTask.projectId })
      .then(reload)
      .finally(() => setUpdating(false));
  };

  return (
    <div className="w-64 h-full flex flex-col gap-4">
      <div className="flex h-full flex-row items-center gap-2">
        <FontAwesomeIcon icon={faComment} size="lg" />
        <VoxelText variant="title2">Comment</VoxelText>
      </div>
      <VoxelTextarea
        id={valueKey}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={'Add url comments...'}
        minRows={20}
        disabled={updating}
        readOnly={updating}
      />
      <div className={'flex flex-row items-center justify-end gap-2'}>
        <VoxelButton
          title={'Undo'}
          disabled={updating || value === initialValue}
          onClick={() => handleCancel()}
          size={'sm'}
          color="light-gray"
          endIcon={<FontAwesomeIcon icon={faArrowRotateBack} size="lg" />}
        />
        <VoxelButton
          type={'submit'}
          title={'Save'}
          disabled={updating || value === initialValue}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit();
          }}
          size={'sm'}
          color="primary"
          endIcon={<FontAwesomeIcon icon={faSave} size="lg" />}
        />
      </div>
    </div>
  );
};

export default ContentTaskComment;
